import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => ({
    stack: { display: 'flex', flexDirection: 'column', gap: 20, [theme.custom.mq.sm]: { gap: 16 } },
    skeletons: { display: 'grid', gap: 16 },
}));
